import classcat from "classcat";
import React, { useCallback } from "react";

import CheckCircleIcon from "@assets/icons/svgr/check-circle.svg";

import { Store } from "@is/types";

import css from "./StoreListingItem.module.css";

type Props = {
  store: Store;
  isSelected?: boolean;
  onClick: (store: Store) => void;
};

const StoreListingItem = ({ store, isSelected, onClick }: Props) => {
  const handleClick = useCallback(() => {
    onClick(store);
  }, [store, onClick]);

  return (
    <div
      onClick={handleClick}
      className={classcat([css.container, { [css.selected]: isSelected }])}
    >
      <div className={css.nameColumn}>{store.name}</div>
      <div className={css.storeIdColumn}>{store.storeId}</div>
      <div className={css.addressColumn}>{store.address}</div>
      {isSelected && (
        <div className={css.checkIconContainer}>
          <CheckCircleIcon />
        </div>
      )}
    </div>
  );
};

export default StoreListingItem;
